import {
  DateRangePickerTextField,
  type IDateRangePickerChip,
  type TDateRangePickerTextField,
  dateRangePickerChipMonth,
  dateRangePickerChipNextMonth,
  dateRangePickerChipNextWeek,
  dateRangePickerChipToday,
  dateRangePickerChipWeek,
  dateRangePickerChipYear,
} from "@inputs/date/DateRangePicker";
import { Controller, type FieldPath, type FieldValues, type UseControllerProps } from "react-hook-form";

export type TDateRangePickerTextFieldFormProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
  TTransformedValues = TFieldValues,
> = Omit<TDateRangePickerTextField, "value"> & UseControllerProps<TFieldValues, TName, TTransformedValues>;

const periodChips = [
  dateRangePickerChipToday,
  dateRangePickerChipWeek,
  dateRangePickerChipNextWeek,
  dateRangePickerChipMonth,
  dateRangePickerChipNextMonth,
  dateRangePickerChipYear,
] as const satisfies IDateRangePickerChip[];

export const DateRangePickerTextFieldForm = <
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
  TTransformedValues = TFieldValues,
>({
  name,
  rules,
  shouldUnregister,
  defaultValue,
  control,
  onChange,
  ...props
}: TDateRangePickerTextFieldFormProps<TFieldValues, TName, TTransformedValues>) => {
  return (
    <Controller
      name={name}
      rules={rules}
      control={control}
      render={({ field: { value, onChange: onChangeForm }, fieldState: { error } }) => (
        <DateRangePickerTextField
          chips={periodChips}
          {...props}
          value={value ?? { startDate: null, endDate: null }}
          onChange={(...args) => {
            if (onChange) {
              onChange(...args);
            }
            onChangeForm(...args);
          }}
          error={Boolean(error)}
          helperText={error?.message}
        />
      )}
    />
  );
};
